import { render, staticRenderFns } from "./KeyStudents.vue?vue&type=template&id=9d90660a&scoped=true"
import script from "./KeyStudents.vue?vue&type=script&lang=js"
export * from "./KeyStudents.vue?vue&type=script&lang=js"
import style0 from "./KeyStudents.vue?vue&type=style&index=0&id=9d90660a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d90660a",
  null
  
)

export default component.exports